import { useEffect } from 'react';
import { AdminTabType, AnalyticsTabType } from '../../../types';
import { DashboardFilterOptions } from '../../FilterPanel/types';
import { useFilterState } from '../../FilterState';
import { UserGroupFilterStateKey } from '../../FilterState/types';
import { trackFilterTypeChange } from './trackFilterTypeChange';

export const useFilterTypeTracking = ({
  dashboardFilterOptions,
  tabType,
  userGroupFilterType,
  userGroupFilterCount,
  isReady,
}: {
  dashboardFilterOptions: DashboardFilterOptions;
  tabType: AdminTabType | AnalyticsTabType;
  userGroupFilterType: UserGroupFilterStateKey | undefined;
  userGroupFilterCount: number;
  isReady: boolean;
}) => {
  const { filterSelectionMethod, timeFilterPreset } = useFilterState();

  useEffect(() => {
    if (!isReady || userGroupFilterType === undefined) {
      return;
    }

    trackFilterTypeChange(
      dashboardFilterOptions[userGroupFilterType],
      tabType,
      userGroupFilterType,
      filterSelectionMethod,
      userGroupFilterCount,
      timeFilterPreset,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isReady,
    tabType,
    filterSelectionMethod,
    userGroupFilterType,
    timeFilterPreset,
  ]);
};
